export const getURLSearchParam = (): URLSearchParams => {
  return new URLSearchParams(window.location.search);
};

export const getQueryParamsObject = (): Record<string, string> => {
  const queryParamsRawObject = getURLSearchParam();

  const queryParamsObject: Record<string, string> = {};
  for (const [key, value] of queryParamsRawObject) {
    queryParamsObject[key] = value;
  }

  return queryParamsObject;
};

export const getFilteredQueryParamsObject = (
  keysToRemove: string[] = []
): Record<string, string> => {
  const queryParamsObject = getQueryParamsObject();

  keysToRemove.forEach((key) => {
    delete queryParamsObject[key];
  });

  return queryParamsObject;
};

export const getSelectedQueryParamsObject = (
  keysToKeep: string[] = []
): Record<string, string> => {
  const queryParamsObject = getQueryParamsObject();
  const filteredParams: Record<string, string> = {};
  keysToKeep.forEach((key) => {
    if (queryParamsObject[key] !== undefined) {
      filteredParams[key] = queryParamsObject[key];
    }
  });

  return filteredParams;
};

/**
 * Get the value of a specific query parameter from the URL.
 *
 * @param {string} paramName - The name of the query parameter to retrieve.
 * @param {string} [url=window.location.href] - Optional: The URL to parse (defaults to current browser URL).
 * @returns {string | null} - The value of the query parameter, or null if not found.
 */
export const getQueryParamValue = (
  paramName: string,
  url: string = window.location.href
): string | null => {
  const params = new URLSearchParams(new URL(url).search);
  return params.get(paramName);
};

export const verifyURLParamsBwLinkAndRedirectionLink = (
  redirectUrl: URL
): string => {
  const redirectUrlParams = redirectUrl.searchParams;
  const currentUrlParams = getURLSearchParam();
  for (const key of Array.from(redirectUrlParams.keys())) {
    const redirectUrlParamValue = redirectUrlParams.get(key);
    const value = currentUrlParams.get(key);
    if (value && !redirectUrlParamValue) {
      redirectUrlParams.set(key, value);
    }
  }
  return redirectUrl.toString();
};

export const removeEmptyParams = (url: string): string => {
  const urlObj = new URL(url);
  const Params = urlObj.searchParams;
  for (const key of Array.from(Params.keys())) {
    const value = Params.get(key);
    if (!value) {
      Params.delete(key);
    }
  }
  return urlObj.toString();
};
